module.exports = __webpack_public_path__ + "developmentProcessCover.4b6760c961c17dc82fd4.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/coverPicks/developmentProcessCover.jpg
// module id = ../../../../../src/assets/coverPicks/developmentProcessCover.jpg
// module chunks = 0